import { STORAGE_KIND_LABEL, type StorageItem } from '@/lib/consent';
import './CookieConsent.css';

export interface CookieCatalogTableProps {
  /** Nome acessível da tabela (e da região que rola na horizontal). */
  caption: string;
  items: readonly StorageItem[];
}

/**
 * O que uma categoria guarda no navegador: nome, provedor, finalidade, duração e
 * tipo. Mesma tabela no painel e na política — as duas leem o catálogo único.
 * Rola dentro do próprio invólucro no celular, nunca a página.
 */
export function CookieCatalogTable({ caption, items }: CookieCatalogTableProps): JSX.Element {
  return (
    // Focável porque rola: quem usa o teclado precisa alcançar a parte escondida.
    <div className="cookie-table" role="region" aria-label={caption} tabIndex={0}>
      <table className="cookie-table__table">
        <caption className="sr-only">{caption}</caption>
        <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">Provedor</th>
            <th scope="col">Finalidade</th>
            <th scope="col">Duração</th>
            <th scope="col">Tipo</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.name}>
              <td className="cookie-table__name">{item.name}</td>
              <td>{item.provider}</td>
              <td>{item.purpose}</td>
              <td>{item.duration}</td>
              <td>{STORAGE_KIND_LABEL[item.kind]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
